import { render } from "./v-checkbox.vue?vue&type=template&id=112cc2fc&scoped=true"
import script from "./v-checkbox.vue?vue&type=script&lang=js"
export * from "./v-checkbox.vue?vue&type=script&lang=js"

import "./v-checkbox.vue?vue&type=style&index=0&id=112cc2fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112cc2fc"]])

export default __exports__